// extracted by extract-css-chunks-webpack-plugin
module.exports = {"menu":"J2UU84wN4XqA","linksContainer":"N-YOl2jDQZoE","isLoggedIn":"uPdO5cQ5I7-R"};